import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { ReactComponent as CrossSvg } from "assets/images/opt/cross.svg";

const TeamCapacityModal = ({
  isOpen,
  onClose,
  history,
  team = {},
  host_remove_modal = { isOpen: false, teammate: "" }
}) => {
  const handleButtonClick = () => {
    if (!host_remove_modal.isOpen) {
      history.push("/pricing_page");
    } else {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      className={`team-modal-main ${host_remove_modal.isOpen ? "my-team" : ""}`}
    >
      <ModalBody>
        <div className="team-capacity-inner">
          <div className="header">
            <h2>
              {host_remove_modal.isOpen
                ? host_remove_modal.teammate === "user"
                  ? "You can not remove the host"
                  : "Host can not remove themselves"
                : "Team capacity exceeded"}
            </h2>
            <div className="cross-icon">
              <CrossSvg onClick={onClose} className="modal-cross" />
            </div>
          </div>
          <div className="body">
            <p>
              {host_remove_modal.isOpen
                ? host_remove_modal.teammate === "user"
                  ? "The host is the creator of the team and is responsible for managing it. Removing the host could disrupt the team's operations."
                  : "The host is the creator of the team and is responsible for managing it. Removing yourself could disrupt the team's operations."
                : `You have exceeded your member limits The current
                  number of members is ${team.count}, but the maximum capacity is
                  ${team.limit}. To continue using the team, you will need to
                  purchase a plan that allows for more members.`}
            </p>
            <button
              className={`modal-button ${
                host_remove_modal.isOpen ? "my-team" : ""
              }`}
              onClick={handleButtonClick}
            >
              {host_remove_modal.isOpen
                ? "Go back to My Team"
                : "View Premium Plans"}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TeamCapacityModal;
